// Page props: a Page-Owned Record (query-omega-oql oql/app/page/page-prop.oql). The frontend
// reaches it ONLY through the three generic public wrappers -- Qo.Public.Api/path-query,
// write-data, delete-data -- never a page-prop-specific endpoint.
export const PagePropTypeText   = "text";
export const PagePropTypeSelect = "select";
export type PagePropType = typeof PagePropTypeText | typeof PagePropTypeSelect;

export const PagePropKey  = "omega/query-omega/page/page-prop/PageProp" as const;
export const PagePropsKey = "omega/query-omega/page/page-prop/PageProps" as const;
export const PathQueryKey = "omega/query-omega/path/path-query/PathQuery" as const;

export interface PagePropOption { label: string; color?: string }

export interface PageProp {
  "type":      typeof PagePropKey;
  "page-id":   string;
  name:        string;
  "prop-type": string;
  options?:    PagePropOption[];
  value?:      string;
}

export interface PagePropsRecord {
  "type":    typeof PagePropsKey;
  "page-id": string;
  props:     Record<string, PageProp>;
}

export interface PagePropsMap {
  [name: string]: { value: string; "prop-type": string; options?: PagePropOption[] };
}

export interface PagePropsState {
  [pageId: string]: PagePropsMap;
}
